import { Box, Spinner } from '@arpeggi/ui'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { IArpMedia } from '../../arp-registry/ArpMedia'
import { useArpSampleUsers } from '../hooks'
import { Card, Collaborators } from '../primitives'

export const ArpSampleUsersCard: FC<{ media: IArpMedia }> = observer(({ media }) => {
  const { type, id, user } = media
  const { walletAddress, profilePicture, displayName } = user
  const { data, hasMore } = useArpSampleUsers(media)
  return (
    <Card.Root css={{ minHeight: '300px' }}>
      <Card.Content>
        <Card.Text title>Sample users</Card.Text>
        <Collaborators.Root>
          <Collaborators.Header>
            <Collaborators.Link noOverflow href={`/profile/${walletAddress}`} target="_blank">
              <Collaborators.Avatar src={profilePicture?.url} />
              <Collaborators.Title big>{displayName}</Collaborators.Title>
              <Collaborators.Title big success>
                Sound Creator
              </Collaborators.Title>
            </Collaborators.Link>
          </Collaborators.Header>
          <Collaborators.Body>
            {data.map((user) => (
              <Collaborators.Link
                key={user.walletAddress}
                href={`/profile/${user.walletAddress}`}
                target="_blank"
              >
                <Collaborators.Avatar src={user.profilePicture?.url} />
                <Collaborators.Title>{user.displayName}</Collaborators.Title>
              </Collaborators.Link>
            ))}
            {hasMore && (
              <Box row alignCenter justifyCenter css={{ flexBasis: '80px' }}>
                <Spinner css={{ strokeWidth: '1.5px' }} />
              </Box>
            )}
          </Collaborators.Body>
        </Collaborators.Root>
      </Card.Content>
    </Card.Root>
  )
})
